module.exports = __webpack_public_path__ + "media/images/generator-adaeb922c54b5363e0c91a6e4d2976f9.svg";